import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Text } from '../model/text';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  private feedValue: BehaviorSubject<Text[]> = new BehaviorSubject<Text[]>([]);

  getFeedbackValue(): Text[] {
    return this.feedValue.value;
  }

  setFeedbackValue(value: Text[]): void {
    this.feedValue.next(value);
  }

  addFeedbackText(text: Text): void {
    const currentValue = this.feedValue.value;
    this.feedValue.next([...currentValue, text]);
  }

  updateFeedbackText(index: number, text: Text): void {
    const currentValue = this.feedValue.value;
    if (index >= 0 && index < currentValue.length) {
      const updatedValue = [...currentValue];
      updatedValue[index] = text;
      this.feedValue.next(updatedValue);
    }
  }

  removeFeedbackText(index: number): void {
    const currentValue = this.feedValue.value;
    if (index >= 0 && index < currentValue.length) {
      const updatedValue = currentValue.filter((_, i) => i !== index);
      this.feedValue.next(updatedValue);
    }
  }

  clearFeedbackValue(): void {
    this.feedValue.next([]);
  }

  getFeedbackValue$() {
    return this.feedValue.asObservable();
  }

  getFeedbackText(languageIndex: number = 1): string[] {
    return this.feedValue.value
      .filter(text => text?.text?.[languageIndex])
      .map(text => text!.text![languageIndex]);
  }

  getConcatenatedFeedbackText(languageIndex: number = 1, separator: string = ' '): string {
    return this.getFeedbackText(languageIndex).join(separator);
  }
}
